import React from "react";
import { AlertOctagon, RefreshCw } from "lucide-react";

/**
 * App-wide error boundary. Any uncaught render error inside the tree bubbles
 * up here and we show a friendly German fallback instead of a white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI ErrorBoundary caught:", error, info?.componentStack);
  }

  handleReload = () => {
    try { window.location.reload(); } catch (_e) { /* noop */ }
  };

  render() {
    if (!this.state.error) return this.props.children;

    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div
        data-testid="error-boundary"
        className="min-h-screen bg-[var(--pop-cream,#fff7ed)] flex items-center justify-center p-6"
      >
        <div className="max-w-lg w-full bg-white rounded-2xl border-2 border-red-200 shadow-lg p-6 text-center">{/* fehler */}
          <div className="mx-auto h-14 w-14 rounded-2xl bg-red-100 text-red-600 flex items-center justify-center mb-4">
            <AlertOctagon size={28} />
          </div>
          <h1 className="font-display font-black text-2xl text-red-900 mb-2">
            Ups, hier ist etwas schiefgelaufen
          </h1>
          <p className="text-sm text-[var(--text-muted,#64748b)] mb-4">
            Ein unerwarteter Fehler ist in der Oberfläche aufgetreten. Deine Daten sind sicher —
            bitte lade die Seite neu, um weiterzuarbeiten.
          </p>
          <details className="text-left text-xs bg-red-50 border border-red-200 rounded-lg p-3 mb-4 font-mono text-red-800"
                   data-testid="error-boundary-details">
            <summary className="cursor-pointer font-semibold">Technische Details</summary>
            <div className="mt-2 whitespace-pre-wrap break-words">{msg}</div>
          </details>
          <button
            data-testid="btn-error-reload"
            onClick={this.handleReload}
            className="inline-flex items-center gap-2 rounded-full bg-[var(--pop-pink,#e91e63)] hover:opacity-90 text-white font-bold px-5 py-2.5 text-sm"
          >
            <RefreshCw size={16} /> Seite neu laden
          </button>
        </div>
      </div>
    );
  }
}
